import {
  LabelRefFragment,
  LabelsQuery,
  useLabelsQuery,
  withStandardListHook,
} from '@spotify/confidence-graphql';

export const useLabels = withStandardListHook<
  LabelsQuery,
  LabelRefFragment,
  'labels'
>(useLabelsQuery, 'labels');
